import React, { Component } from 'react';
import { Button, Box, Dialog, DialogContent, FormControl } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import api from '../../../services/api';
import { diff } from 'deep-diff';
import AlertInformation from 'components/AlertInformation/AlertInformation';
import ComboPadrao from 'views/Components/ComboPadrao';
import { validateField } from 'lib/functions';

// Definição dos estilos
const styles = theme => ({
    textField: {
        marginTop: theme.spacing(0),
        marginBottom: "0.5rem",
        marginRight: "0.5rem",
        variant: "outlined"
    },
    addButton: {
        height: '42px',
        display: 'flex',
        alignItems: 'center',
        float: 'right',
    },
    modalContent: {
        maxHeight: '100vh', // Ajuste a altura máxima conforme necessário
        overflowY: 'auto', // Permite rolar verticalmente
        width: '50vh'
    },
    helperTextError: {
        color: 'red',
    }
});

class GrupoServicoForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            servicogrupo: {
                codservicoprincipal: this.props.codServico
            },
            servicogrupo_original: {},
            servicos: [],
            errors: {},
            schema: {
                codservicogrupo: {
                    presence: { allowEmpty: false, message: 'Serviço obrigatório' },
                    length: { maximum: 10 },
                    type: 'select-one'
                }
            },
            isNewRecord: false,
            openAlert: false,
            messageAlert: ''
        };
    }

    async componentDidMount() {
        let id = this.props.id;
        let servicogrupoData;

        if (id > 0) {
            if (this.props.codServico === undefined) {
                servicogrupoData = this.props.servicogrupo;
            } else {
                const response = await api.get(`/servico/grupo/${id}`);
                servicogrupoData = response.data.data[0];
            }

            this.setState({
                servicogrupo: servicogrupoData,
                servicogrupo_original: JSON.parse(JSON.stringify(servicogrupoData)),
                isNewRecord: false
            });

            const servicos = await api.get(`/servico/listforchange/${servicogrupoData.id}?limit=1000`);
            this.setState({ servicos: servicos.data.data });

        } else if (id === 'novo') {
            this.setState({ isNewRecord: true });

            this.setState(prevState => ({
                servicogrupo: {
                    ...prevState.servicogrupo
                }
            }));

            const servicos = await api.get(`/servico/active/true?limit=1000`);
            this.setState({ servicos: servicos.data.data });
        }
    }

    handleCancel = () => {
        this.props.onClose();
    };

    OnChange = (event) => {
        const { servicogrupo } = this.state;
        const { name, type, value } = event.target;
        let adjustedValue = Number(value);

        this.setState(prevState => ({
            servicogrupo: {
                ...prevState.servicogrupo,
                [name]: adjustedValue
            },
            errors: {
                ...prevState.errors,
                [name]: typeof adjustedValue === 'string' && adjustedValue.trim() === ''
            }
        }));

    }

    onClickSave = () => {
        if (this.state.isNewRecord) {
            this.insereServicoGrupo();
        } else {
            this.atualizaServicoGrupo();
        }
    }

    insereServicoGrupo = async () => {
        const { servicogrupo } = this.state;

        /* */

        try {
            if (!(this.props.codServico === undefined)) {
                const response = await api.post(`/servico/grupo`, servicogrupo);
                if (response.status === 200) {
                    this.handleCancel();
                    this.props.onSave();
                }
            } else {
                this.handleCancel();
                this.props.onSave(this.state.servicogrupo);
            }
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
        }
    }

    atualizaServicoGrupo = async () => {
        const { servicogrupo, servicogrupo_original } = this.state;

        const differences = diff(servicogrupo_original, servicogrupo);

        if (!differences) {
            this.handleCancel();
            return;
        }

        const servicogrupoAlterado = {};
        differences.forEach(d => {
            if (d.kind === 'E' || d.kind === 'N') {
                servicogrupoAlterado[d.path.join('.')] = d.rhs;
            }
        });

        try {
            if (!(this.props.codServico === undefined)) {
                const response = await api.put(`/servico/grupo/${servicogrupo.id}`, servicogrupoAlterado);
                if (response.status === 200) {
                    this.handleCancel();
                    this.props.onSave();
                }
            } else {
                this.handleCancel();
                this.props.onSave(this.state.servicogrupo);
            }
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
        }
    }

    validationRequiredFields = () => {
        const { servicogrupo } = this.state;
        const { schema } = this.state;
        let errors = {};
        const servicoError = validateField('codservicogrupo', servicogrupo.codservicogrupo, schema);
        if (servicoError) {
            errors.codservicogrupo = servicoError;
        }
        return errors;
    };

    handleSubmit = () => {
        let errors = this.validationRequiredFields();
        this.setState({ errors });
        if (Object.keys(errors).length === 0) {
            this.onClickSave();
        }
    };

    handleOpenAlert = (message) => {
        this.setState({ openAlert: true, messageAlert: message });
    };

    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    render() {
        const { isModal, classes } = this.props;

        const { servicogrupo } = this.state;
        const { servicos } = this.state;

        const { errors } = this.state;

        return (
            <Dialog open={isModal} onClose={this.handleCancel} maxWidth="sm" fullWidth>
                <DialogContent
                // className={classes.modalContent}
                >

                    <FormControl
                        fullWidth
                        variant="outlined"
                    >
                        <ComboPadrao
                            name={'codservicogrupo'}
                            label={'Serviço'}
                            value={servicogrupo.codservicogrupo}
                            onChange={this.OnChange}
                            fieldId={'codservico'}
                            listItems={servicos}
                            fieldDescription={'descservico'}
                            helperText={errors.codservicogrupo || ''}
                            error={!!errors.codservicogrupo}
                        />
                    </FormControl>                                

                    <br />
                    <br />

                    <Box style={{ float: 'right' }}>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={this.handleSubmit}
                            style={{ marginRight: '5px' }}
                        >
                            Salvar
                        </Button>

                        {isModal && (
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={this.handleCancel}
                            >
                                Cancelar
                            </Button>
                        )}
                    </Box>

                    <div>
                        <AlertInformation
                            open={this.state.openAlert}
                            handleClose={this.handleCloseAlert}
                            message={this.state.messageAlert}
                        />
                    </div>
                </DialogContent>
            </Dialog>
        );
    }
}

export default withStyles(styles)(GrupoServicoForm);